var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filter",
    class: {
      filter_search: _vm.type === 'search'
    }
  }, [_c('div', {
    staticClass: "filter__list"
  }, [_vm._l(_vm.list, function (group) {
    return _c('div', {
      key: group.id,
      staticClass: "filter__group"
    }, [group.isMain || _vm.showAllFilters ? [group.type === 'checkbox' ? _c('LazyHydrate', {
      attrs: {
        "when-idle": ""
      }
    }, [_c('FilterCheckbox', {
      attrs: {
        "value": _vm.innerValue,
        "list": group.filter,
        "name": group.name,
        "initial-toggle": group.isOpenFilter,
        "theme": "white"
      },
      on: {
        "change": _vm.change
      }
    })], 1) : group.type === 'range' ? _c('LazyHydrate', {
      attrs: {
        "when-idle": ""
      }
    }, [_c('FilterRange', {
      attrs: {
        "value": _vm.innerValue,
        "filter": group.filter,
        "name": group.name,
        "initial-toggle": group.isOpenFilter
      },
      on: {
        "change": _vm.change
      }
    })], 1) : _vm._e()] : _vm._e()], 2);
  }), _vm._v(" "), _c('div', {
    staticClass: "filter__button-wrap filter__button-wrap_desktop"
  }, [_c('Button', {
    attrs: {
      "theme": "white",
      "fluid": "",
      "icon": "back",
      "data-e2e": "catalog-filter-reset-submit"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("\n        Сбросить\n      ")]), _vm._v(" "), !_vm.isBasic ? _c('div', {
    staticClass: "filter__button-toggle",
    on: {
      "click": function ($event) {
        _vm.showAllFilters = !_vm.showAllFilters;
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.showAllFilters ? 'Скрыть' : 'Показать') + " все фильтры\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "filter__button-wrap filter__button-wrap_mobile"
  }, [_c('Button', {
    staticClass: "filter__accept-wrap",
    attrs: {
      "fluid": "",
      "icon": "tick",
      "data-e2e": "catalog-filter-mobile-submit",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        Применить фильтры\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "filter__reset-wrap"
  }, [_c('span', {
    staticClass: "filter__reset-link",
    attrs: {
      "data-e2e": "catalog-filter-reset-submit-mobile"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Сбросить")])])], 1)], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }